import React, { createContext, useContext, useMemo, useState } from 'react';

interface FiltersPanelContextValue {
  isFiltersPanelOpen: boolean;
  openFiltersPanel: () => void;
  closeFiltersPanel: () => void;
}

const FiltersPanelContext = createContext<FiltersPanelContextValue>({
  isFiltersPanelOpen: false,
  openFiltersPanel: () => {},
  closeFiltersPanel: () => {},
});

export const FiltersPanelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isFiltersPanelOpen, setIsFiltersPaneOpen] = useState(false);

  const value = useMemo(
    () => ({
      isFiltersPanelOpen,
      openFiltersPanel: () => setIsFiltersPaneOpen(true),
      closeFiltersPanel: () => setIsFiltersPaneOpen(false),
    }),
    [isFiltersPanelOpen]
  );

  return (
    <FiltersPanelContext.Provider value={value}>
      {children}
    </FiltersPanelContext.Provider>
  );
};

export const useFiltersPanel = () => useContext(FiltersPanelContext);
